<mat-card class="category" *ngIf="categories">
    <mat-card-title class="category--search">Product search</mat-card-title>
    <div class="category--field">
      <mat-icon matPrefix>search</mat-icon>
      <input class="category--field__input" type="text" matInput (keyup)="onTextFilterChange($event)">
    </div>
  </mat-card>
<mat-card class="category" *ngIf="categories">
  <mat-card-title class="category--search">Categories</mat-card-title>
      <mat-selection-list class="category--list" (selectionChange)="onSelection($event, catList.selectedOptions)" #catList>
          <mat-list-option class="category--list_item" *ngFor="let cat of categories" [value]='cat.Id'>
              <span>{{cat.Name}}</span>
          </mat-list-option>
      </mat-selection-list>
</mat-card>
